/** EN catalog — FE-6: session delivery, notes, corrections, payments. */
export const sessionsEn: Record<string, string> = {
  'ss.chip.delivered': 'Delivered',
  'ss.chip.not_recorded': 'Not recorded',
  'ss.chip.upcoming': 'Upcoming',
  'ss.chip.cancelled': 'Cancelled',
  'ss.chip.no_show': 'No-show',
  'ss.record': 'Record delivery',
  'ss.viewSession': 'View session',
  'ss.dayFoot':
    'A cancelled or no-show booking cannot be delivered; and a booking with an effective delivery can no longer be cancelled, marked no-show, or rescheduled.',

  'ss.recTitle': 'Record session delivery',
  'ss.recSub':
    'The session you just delivered, in your words. The delivering practitioner and the time are not form fields — the time is stamped at save.',
  'ss.bookingStrip': 'Booking · {when}',
  'ss.bookingText': '{patient} · booked practitioner {who} — nothing is stored until you save.',
  'ss.viewBooking': 'View booking',
  'ss.ctxTitle': 'Recording context',
  'ss.deliverer': 'Delivering practitioner',
  'ss.delivererHelp': 'From the booking — shown for context, not a choice.',
  'ss.delivererNotYou':
    'You are recording this on the booked practitioner’s behalf; the recording is attributed to you, the delivery to them.',
  'ss.ctxNote':
    'The delivery time is stamped when you save — there is no clock to set. The recording is attributed to you automatically.',
  'ss.pkgTitle': 'Package context',
  'ss.pkgSub': 'Package attribution comes from the booking itself and is not chosen here.',
  'ss.pkgLine': '{name} — {planned, plural, one {# planned session} other {# planned sessions}}',
  'ss.pkgHelp':
    '{delivered} delivered · {planned} planned — after this save: {after} delivered. Counts derive from effective sessions; no session owns a permanent number.',
  'ss.pkgNone': 'Ad-hoc session — not part of a package.',
  'ss.notesTitle': 'Clinical notes',
  'ss.notesSub':
    'Two optional free-text fields — no templates, categories or scores. After the final save they cannot be edited.',
  'ss.notes': 'Session notes',
  'ss.notesPh': 'What happened in the session…',
  'ss.outcome': 'Outcome / progress observations',
  'ss.outcomeHelp':
    'Plain clinical prose — not structured Goals or scores; the Progress model is the next build’s question.',
  'ss.outcomePh': 'Optional…',
  'ss.readBackTitle': 'Read the transcript back',
  'ss.readBackBody':
    'Dictation mishears names, numbers and negations — “did” and “did not” are one sound apart. After the final save, the note can no longer be edited.',
  'ss.reviewSave': 'Review & save…',
  'ss.saveNote':
    'Saving stamps the delivery time and seals the notes — you will review before anything is saved.',
  'ss.confirmTitle': 'Save this delivery — the notes become permanent',
  'ss.confirmBody': 'Read once more, especially anything dictated. What is saved is what stays.',
  'ss.fact.sealed':
    'Session notes and observations cannot be edited after saving — review them now.',
  'ss.fact.attrib': 'Recorded as {who} — the delivery time is stamped now, at save.',
  'ss.fact.package':
    'Package: {delivered} delivered of {planned} planned — after this save: {after} delivered.',
  'ss.fact.lock': 'The booking can no longer be cancelled, marked no-show, or rescheduled.',
  'ss.fact.void':
    'If the delivery itself was recorded in error, authorized staff may void it — voiding retracts the whole recording, it never edits a note.',
  'ss.confirmNote': 'Payment is reception’s separate step — nothing financial happens here.',
  'ss.keepEditing': 'Keep editing',
  'ss.saveDelivery': 'Save delivery',
  'ss.empty': '(empty)',

  'ss.overPlanTitle': 'Beyond the package plan — priced from the catalogue',
  'ss.overPlanBody':
    '{delivered} of {planned} planned sessions are already delivered. This one is still recorded; its amount comes from the clinic catalogue, not the package. A reason is optional.',
  'ss.overPlanReason': 'Reason (optional)',
  'ss.fact.overPlan':
    'Package: beyond the plan ({delivered} of {planned} delivered) — this delivery is priced from the clinic catalogue.',
  'ss.redeliveredErr':
    'This booking was delivered again after the void — void the newer delivery first.',
  'ss.capacityOver':
    'This line is now over-delivered by {n} — sessions beyond the plan were delivered at the catalogue price.',
  'ss.reinstateOverWarn':
    'The plan is already consumed ({delivered} of {planned} delivered). Reinstating makes this line over-delivered — allowed, and shown as such.',
  'ss.amountTitle': 'Amount',
  'ss.priceBasis': 'Basis',
  'ss.err.alreadyDelivered':
    'This booking already has a delivery recorded — the page has been refreshed.',
  'ss.err.notActive': 'This booking is cancelled or no-show and cannot be delivered.',

  'ss.detailTitle': 'Delivered session',
  'ss.detailSub':
    'The delivery record — who, when, with which notes. Notes are sealed; if the delivery itself was recorded in error, authorized staff may void the recording.',
  'ss.detailVoidedSub':
    'Voided — but not deleted: the session, its notes and its history stay visible; it just no longer counts toward the package.',
  'ss.effective': 'Effective',
  'ss.voided': 'Voided',
  'ss.notCounting': 'Not counting toward the package',
  'ss.countChip': '{delivered} delivered of {planned} planned',
  'ss.deliveredBy': 'Delivered by {who} · recorded by {rec} · saved {when}',
  'ss.deliveredBySame': 'Delivered & recorded by {who} · saved {when}',
  'ss.voidedBy': 'Voided by {who} · {when} — reason: {reason}',
  'ss.void': 'Void…',
  'ss.reinstate': 'Reinstate…',
  'ss.ledgerTitle': 'This session’s history',
  'ss.ledgerSub':
    'Correction told honestly: recorded, then voided with a reason — nothing is deleted.',
  'ss.ledger.recorded': 'Recorded',
  'ss.ledger.void': 'Voided',
  'ss.ledger.reinstate': 'Reinstated',
  'ss.ledgerRecorded': 'Delivered by {who} · notes entered at recording — time stamped at save.',
  'ss.ledgerReason': 'Reason: {reason}',
  'ss.sealedTitle': 'Clinical notes are sealed after saving',
  'ss.sealedBody':
    'There is no Edit-note action — deliberately; the protection was the review before saving. Voiding is a different thing: retracting the whole delivery as a clinical fact, never editing a note.',
  'ss.permTitle': 'Void and reinstate are permission-aware',
  'ss.permBody':
    'Those actions appear only for staff with the correction capability — everyone else still sees the state and the full history, with no dead buttons.',
  'ss.afterVoidTitle': 'After a void the booking is live again',
  'ss.afterVoidBody':
    'It can be rescheduled, cancelled, marked no-show — or delivered again as a NEW session row; this voided row stays in history. Any money this session had taken is credit on the patient account again.',
  'ss.reinstateNoteTitle': 'Reinstating also requires a reason',
  'ss.reinstateNoteBody':
    'Reinstate mirrors the void dialog with its own mandatory reason; the session becomes effective and counts again.',
  'ss.voidTitle': 'Void this delivery',
  'ss.voidBody':
    'Voiding retracts this whole delivery as a clinical fact — it is not a way to edit a note. Nothing is deleted; only the package count stops including it.',
  'ss.voidReason': 'Reason for voiding',
  'ss.reinstateTitle': 'Reinstate this delivery',
  'ss.reinstateBody':
    'The session becomes effective again and counts toward the package. The reason is recorded in the session’s history, attributed, permanently.',
  'ss.reinstateReason': 'Reason for reinstating',
  'ss.reasonHelp': 'Recorded in the session’s history, attributed, permanently.',
  'ss.voidFact1': 'Stops counting toward the package — the remainder recomputes.',
  'ss.voidFact2': 'The clinical notes remain readable and still cannot be edited.',
  'ss.voidFact3': 'Reinstating later is possible — with its own mandatory reason.',
  'ss.voidNote':
    'Re-delivering this booking is not promised here — the booking’s fate after a void is under architecture review.',
  'ss.neverMind': 'Never mind',
  'ss.voidCta': 'Void the delivery',
  'ss.reinstateCta': 'Reinstate the delivery',
  'ss.err.correctionState': 'The session is already in that state — the page has been refreshed.',
  'ss.openBooking': 'Open the booking',
  // ZOY-686: the shared Group Report on an attendee's session record.
  'ss.groupChip': 'Group session',
  'ss.groupReportTitle': 'Group report',
  'ss.groupReportSub':
    'Written once for the whole group session; the notes above are this attendee’s own.',
  'ss.groupReportBy': 'Written by {who} · {when}',
  'ss.openPatient': 'Open the record',

  'ss.histTitle': 'Sessions',
  'ss.histSub':
    'Every recorded delivery — effective and voided side by side, because honest history shows both. Package progress derives from effective ones only.',
  'ss.histEmpty': 'No delivered sessions yet.',
  'ss.histFoot':
    'Delivered counts always recompute from effective sessions — they shift with every void or reinstate.',
  'ss.colDate': 'Date',
  'ss.colSession': 'Session',
  'ss.colBy': 'Delivered by',
  'ss.colState': 'State',
  'ss.hasNotes': 'has notes',
  'ss.voidReasonSub': 'reason: {reason}',
  'ss.noDeleteTitle': 'Nothing is ever deleted',
  'ss.noDeleteBody':
    'A voided row fades but stays — the clinical and financial record of what happened remains readable forever.',
  'ss.sessionNotFound': 'No delivered session is recorded for this booking yet.',

  'py.title': 'Payments',
  'py.queueSub':
    'Effective delivered sessions whose payment isn’t recorded yet — every unpaid session stays here, however old, until payment is received.',
  'py.historySub':
    'Every payment recorded — from a session or on the patient account — one row per payment at its own amount, with what it settled. Reversed payments stay, marked. The period is the date received, the same as Received.',
  'py.limitedSub':
    'The same workspace, shaped by access — recording and correcting payments isn’t available to this role, and the list is read-only.',
  'py.tab.unpaid': 'Outstanding',
  'py.tab.history': 'Payment history',
  'py.f.patient': 'Patient',
  'py.f.date': 'Date',
  'py.f.allTime': 'All time',
  'py.f.service': 'Service',
  'py.f.practitioner': 'Practitioner',
  'py.f.method': 'Method',
  'py.f.state': 'Session state',
  // ZOY-647: the payment history's own filters and columns.
  'py.f.status': 'Status',
  'py.colReceived': 'Received',
  'py.colPayment': 'Payment',
  'py.colSettled': 'Settled',
  'py.colStatus': 'Status',
  'py.sort.newestReceived': 'Newest received first',
  'py.hist.file': 'File {n, number}',
  'py.hist.notApplied': 'Not applied yet — held as credit',
  'py.historyTotal':
    '{amount} received across {n, plural, one {# payment} other {# payments}} in this filter · reversed: {reversed} ({m, number})',
  'py.f.all': 'All',
  'py.f.from': 'From',
  'py.f.to': 'To',
  'py.sort.oldest': 'Oldest unpaid first',
  'py.sort.newest': 'Newest first',
  'py.colPatient': 'Patient',
  'py.colSession': 'Session',
  'py.colDelivered': 'Delivered',
  'py.colAmount': 'Amount',
  'py.colPaidAt': 'Paid at',
  'py.colMethod': 'Method',
  'py.colState': 'Session state',
  'py.record': 'Record payment',
  'py.view': 'View',
  'py.queueTotal':
    'Still owed for this filter: {amount} across {n} sessions — the clinic system’s sum over the whole list, not this page.',
  'py.queueEmptyTitle': 'Nothing waiting',
  'py.queueEmptyBody':
    'Every delivered session has its payment recorded. New deliveries will appear here — and staying unpaid until payment is received is normal.',
  'py.historyEmptyTitle': 'No payments recorded yet',
  'py.historyEmptyBody': 'Recorded payments will appear here.',
  'py.filteredEmptyTitle': 'Nothing matches these filters',
  'py.filteredEmptyBody':
    'The filters — not the data — emptied this list. Clear them to see everything again.',
  'py.filteredEmptyUnpaid':
    '{n, plural, one {# unpaid session exists} other {# unpaid sessions exist}} in the clinic, but none match the current filters. Nothing here means "all paid".',
  'py.clearFilters': 'Clear the filters',
  'py.limitedTitle': 'Recording & correcting payments',
  'py.limitedChip': 'Not in your access',
  'py.limitedBody':
    'Recording and correcting payments aren’t part of your role. The list stays read-only for awareness.',
  'py.partial': 'Partly paid',
  'py.paidOfTotal': '{paid} of {total} paid',
  'py.tab.balances': 'Balances',
  'py.tab.received': 'Received',
  'py.patientAccount': 'Patient account',
  'py.legacyAttentionTitle': 'Needs financial attention (legacy)',
  'py.legacyAttentionBody':
    '{n, plural, one {# voided session still carries} other {# voided sessions still carry}} a payment recorded before the patient account existed — that money was never modelled. Review and settle by hand.',
  'py.legacyAttentionShow': 'Show them',
  'py.legacyRow': 'Voided with a payment recorded before the patient account — settle by hand.',
  'py.notReversibleHere':
    'That payment also settles other sessions — reverse it from the patient account instead.',
  'py.openAccount': 'Open the patient account',
  'py.priceBasis.package_slot': 'Package slot',
  'py.priceBasis.catalog': 'Catalogue price',
  'py.overPlan': 'Beyond the plan',
  'py.overPlanReason': 'Reason: {reason}',
  'py.correctAmount': 'Correct the amount…',
  'py.correctAmountTitle': 'Correct this over-plan amount',
  'py.correctAmountBody':
    'This delivery is beyond the package plan and took the catalogue price. Set the agreed amount: the change is ledgered in the patient’s history, and anything already paid above it becomes credit.',
  'py.correctAmountField': 'Agreed amount',
  'py.correctAmountReason': 'Reason (optional)',
  'py.correctAmountCta': 'Save the amount',
  'py.correctAmountLocked': 'Only an effective over-plan delivery’s amount can be corrected.',
  'py.amountCorrected': 'Amount corrected: {from} → {to}.',
  'py.upfrontWarn':
    '{name}: upfront payment expected — {received} of {total} received, {shortfall} outstanding. Information only; nothing is blocked.',
  'py.acct.title': '{name}’s account',
  'py.acct.sub':
    'Debt, credit and every payment, as the clinic system holds them. Nothing on this screen is computed here.',
  'py.acct.debt': 'Owed by the patient',
  'py.acct.credit': 'Credit held',
  'py.acct.net': 'Net balance',
  'py.acct.netOwes': 'The patient owes',
  'py.acct.netCredit': 'In the patient’s favour',
  'py.acct.netSettled': 'Settled',
  'py.acct.creditGeneral': 'General: {amount}',
  'py.acct.creditFor': '{name}: {amount}',
  'py.acct.openTitle': 'Open charges',
  'py.acct.openSub':
    'Delivered sessions with money still owed — oldest first, the order money is applied in.',
  'py.acct.openNone': 'Nothing owed.',
  'py.acct.outstanding': '{amount} still owed',
  'py.rec.title': 'Record a payment',
  'py.rec.sub':
    'Money received now. It is applied to the oldest open charges automatically — earmarked money only to its package; the rest stays as credit.',
  'py.rec.amount': 'Amount received',
  'py.rec.amountHelp': 'In the clinic’s storage currency, as entered on the receipt.',
  'py.rec.receivedDate': 'Received on',
  'py.rec.receivedTime': 'At',
  'py.rec.receivedHelp': 'Prefilled with now — move it back for money taken earlier.',
  'py.rec.earmark': 'Earmark',
  'py.rec.earmarkHelp':
    'Optional. Earmarked money settles only that package’s sessions and otherwise stays as that package’s credit.',
  'py.rec.general': 'General — any session',
  'py.rec.note': 'Note',
  'py.rec.cta': 'Record the payment',
  'py.rec.now': 'Recorded at the moment you confirm.',
  'py.rec.earlier': 'Received earlier? Set the date and time',
  'py.rec.earlierOff': 'Record it as received now',
  'py.rec.addNote': 'Add a note',
  'py.rec.hideNote': 'No note',
  // The fast path: one session, its own remaining amount, recorded now.
  'py.qp.title': 'Record payment',
  'py.qp.sub': 'For this session only — recorded now and applied to this session first.',
  'py.qp.amount': 'Amount received',
  'py.qp.amountHelp':
    'Prefilled with what this session still owes; change it if the family paid a different amount.',
  'py.qp.equals': '= {amount}',
  'py.qp.owes': 'This session still owes {amount}.',
  'py.qp.remaining': '{paid} of {total} already paid.',
  'py.qp.partialNote':
    'Less than what this session owes: it becomes partly paid, with {remaining} still owed. Nothing moves to any other session.',
  'py.qp.overNote':
    'More than what this session owes: {excess} goes on to the patient’s other open charges, oldest first — or stays as credit if nothing else is owed.',
  'py.qp.overNotePackage':
    'More than what this session owes: {excess} goes on to this package’s other open sessions, oldest first — or stays as credit for this package. It never settles debt outside the package.',
  'py.qp.receivedNow': 'Received now — the time is set when you confirm.',
  'py.qp.receivedAt': 'Received {when}',
  'py.qp.confirm': 'Record {amount} · {method}',
  'py.qp.done': 'Payment recorded.',
  'py.qp.unavailable': 'This session cannot take a payment here.',
  'py.qp.errAmount': 'Enter an amount greater than zero.',
  'py.qp.errDate': 'That date and time cannot be recorded. Check them and try again.',
  'py.qp.errVoided':
    'This session was voided — nothing can be received for it. Reinstate it first, or record the money on the patient account.',
  'py.qp.errGone': 'This session no longer exists in this clinic.',
  'py.rec.done': 'Payment recorded — the account above is already up to date.',
  'py.rec.errMismatch': 'That package is not this patient’s. Nothing was recorded.',
  'py.hist.title': 'Payments',
  'py.hist.sub':
    'Every payment ever recorded. A reversed one stays here, struck through, with its reason — nothing is edited or deleted.',
  'py.hist.chipRecorded': 'Recorded',
  'py.hist.chipReversed': 'Reversed',
  'py.hist.none': 'No payment recorded yet.',
  'py.hist.applied': '{applied} applied · {unapplied} held as credit',
  'py.hist.earmarked': 'earmarked to {name}',
  'py.hist.reversed': 'Reversed {when} by {who} — {reason}',
  'py.hist.reversedFromSession': 'Reversed {when} by {who} — by marking its session unpaid',
  'py.hist.reverse': 'Reverse…',
  'py.hist.reverseTitle': 'Reverse this payment',
  'py.hist.reverseBody':
    'Nothing is edited or deleted: the payment stays in history as reversed, every session it settled goes back to owing, and a correct payment can be recorded afresh.',
  'py.hist.reverseReason': 'Why the payment is wrong',
  'py.hist.reverseCta': 'Reverse the payment',
  'py.hist.errReversed': 'This payment was already reversed — the list has been refreshed.',
  'py.alloc.auto': 'applied',
  'py.alloc.session_direct': 'applied to the session directly',
  'py.alloc.session_voided': 'released — session voided',
  'py.alloc.payment_reversed': 'released — payment reversed',
  'py.alloc.amount_reduced': 'released — amount reduced',
  'py.fund.title': 'Packages',
  'py.fund.terms.per_session': 'Paid per session',
  'py.fund.terms.upfront_expected': 'Upfront expected',
  'py.fund.total': 'Package total',
  'py.fund.earmarked': 'Earmarked received',
  'py.fund.credit': 'Earmarked credit',
  'py.fund.charged': 'Charged to date',
  'py.fund.paid': 'Paid to date',
  'py.fund.outstanding': 'Still owed',
  'py.fund.shortfall': 'Upfront shortfall: {amount} — information only; nothing is blocked.',
  'py.bal.title': 'Patient balances',
  'py.bal.sub':
    'Every patient with money owed or credit held, largest debt first — the clinic system’s account figures.',
  'py.bal.colPatient': 'Patient',
  'py.bal.colOwed': 'Owed',
  'py.bal.colCredit': 'Credit',
  'py.bal.colNet': 'Net',
  'py.bal.totals':
    '{debt, plural, one {# patient owes} other {# patients owe}} {owed} · {credit, plural, one {# holds} other {# hold}} {held} in credit',
  'py.bal.truncated': 'Only the first {n} patients are listed; the totals cover those rows.',
  'py.bal.none': 'No patient owes or holds anything.',
  'py.bal.limit': 'Rows',
  'py.rcv.title': 'Payments received',
  'py.rcv.sub': 'Recorded payments by method for the period; reversals are shown apart.',
  'py.rcv.total': '{amount} across {n, plural, one {# payment} other {# payments}}',
  'py.rcv.reversed': 'Reversed in the period: {amount}',
  'py.rcv.none': 'No payment recorded in this period.',
  'py.rcv.thisMonth': 'This month',
  'py.paid': 'Paid',
  'py.unpaid': 'Unpaid',
  'py.method.pos_card': 'POS card',
  'py.method.online': 'Online',
  'py.method.cash': 'Cash',
  'py.method.card_to_card': 'Card-to-card',
  'py.method.none': '—',

  'py.recTitle': 'Record a payment',
  'py.recSub':
    'The amount is fixed; choose the method and confirm — the payment time is recorded automatically at confirmation.',
  'py.sessionCard': 'The delivered session',
  'py.patient': 'Patient',
  'py.service': 'Service',
  'py.practitioner': 'Practitioner',
  'py.delivered': 'Delivered',
  'py.amount': 'Payable amount',
  'py.amountHelp': 'Set when the session was delivered — not editable.',
  'py.methodTitle': 'Payment method',
  'py.methodSub':
    'Required to mark as paid — POS card is preselected; tap another method to change it before confirming.',
  'py.selected': 'Selected',
  'py.barNote': 'The payment time is set by the system at confirmation.',
  'py.confirmPaid': 'Confirm — mark as paid',
  'py.alreadyPaid': 'This session is already recorded as paid.',
  'py.voidedNoRecord': 'This session is voided — it is not a payment work item.',

  'py.detailTitle': 'Session payment',
  'py.detailSub':
    'The recorded payment of a delivered session — the amount is fixed, and Paid is not a casual toggle.',
  'py.detailUnpaidSub':
    'A delivered session without a recorded payment — unpaid is a normal state until payment is received.',
  'py.voidedPaidSub':
    'Voided, with a payment recorded before the patient account existed — that money was never modelled. Settle by hand.',
  'py.strip': '{amount} · {method} · paid {when} — the payment time was set by the system.',
  'py.stripUnpaid': '{amount} · unpaid — until payment is received, nothing else changes.',
  'py.stripVoidedPaid':
    'Voided {voided} — the payment stays as recorded: {amount} · {method} · {when}.',
  'py.sessionTitle': 'The session',
  'py.paymentTitle': 'The payment',
  'py.paidAt': 'Paid at',
  'py.paidAtHelp': 'Set by the system.',
  'py.method': 'Method',
  'py.notToggleTitle': 'Paid is not a toggle',
  'py.notToggleBody':
    'A paid mark records money for this session’s remaining amount and applies it here. Correcting to unpaid reverses only the payment applied solely to this session — otherwise reverse the payment itself from the patient account.',
  'py.correct': 'Correct to unpaid',
  'py.correctTitle': 'Correct this payment to unpaid?',
  'py.correctBody':
    'This removes the Paid status and the {method} method from this session. The payable amount does not change.',
  'py.correctWarn':
    'If payment is recorded again later, a new payment time will replace the current one ({when}).',
  'py.correctAck':
    'I understand the current payment time will be replaced if payment is recorded again.',
  'py.keepPaid': 'Keep as paid',
  'py.deliveredVoided': 'Delivered · voided',
  'py.voidedSameDay': 'voided {when}',

  'py.patientTitle': '{name}’s payments',
  'py.patientSub':
    'Unpaid deliveries, payment history and package consumption — session counts and recorded payments only.',
  'py.consumption': 'Session consumption',
  'py.inDelivery': 'In delivery',
  'py.completed': 'Completed',
  'py.pricingContext': 'Package price {price}{discount} — pricing context only.',
  'py.discountPct': ' · {pct}% discount',
  'py.discountFixed': ' · {amount} discount',
  'py.planned': 'Planned',
  'py.deliveredEffective': 'Delivered effective',
  'py.scheduledAhead': 'Scheduled ahead',
  'py.remainingToSchedule': 'Remaining to schedule',
  'py.viewPackage': 'View package',
  'py.unpaidSessions': 'Unpaid delivered sessions',
  'py.unpaidNone': 'Nothing unpaid.',
  'py.paymentHistory': 'Payment history',
  'py.noPackages': 'No packages.',
  'py.openPayments': 'Payments',
  'rec.paymentsSub': 'Unpaid deliveries, payment history and package consumption.',
  'rec.sessionsSub': 'Every recorded delivery on this record.',

  // --- Voice dictation (ZOY-483..488) ---------------------------------------
  'vr.record': 'Record',
  'vr.stop': 'Stop recording',
  'vr.reRecord': 'Record again',
  'vr.discard': 'Discard recording',
  'vr.play': 'Play',
  'vr.pause': 'Pause',
  'vr.loading': 'Opening…',
  'vr.playFailed': 'That recording could not be played just now. Try again.',
  'vr.requesting': 'Waiting for microphone permission…',
  'vr.recordingNow': 'Recording. It stops on its own at {max}.',
  'vr.nearLimit': 'Nearly at the {max} limit — recording will stop on its own.',
  'vr.ceilingHit':
    'Recording stopped at the {max} limit. What you recorded is safe — record again if you need more.',
  'vr.uploading': 'Uploading… {pct, number}%',
  'vr.uploadProgress': 'Upload progress',
  'vr.cancelUpload': 'Cancel upload',
  'vr.transcribing': 'Transcribing. You can keep typing — nothing is inserted until you choose to.',
  'vr.unsupported': 'This browser cannot record audio. Typing works as usual.',
  'vr.typeInstead': 'You can type instead — the field always works.',
  'vr.micTitle': 'Microphone not available',
  'vr.mic.denied':
    'Microphone access was refused. Allow it in your browser’s site settings, then record again. Typing always works.',
  'vr.mic.notFound': 'No microphone was found. Connect one and try again, or type instead.',
  'vr.mic.busy':
    'The microphone is in use by another application. Close it and try again, or type instead.',
  'vr.mic.other': 'The microphone could not be opened. Try again, or type instead.',
  'vr.draftTitle': 'Machine transcript — a draft for you to check',
  'vr.draftHint': 'Nothing is added to the field until you choose Append or Replace.',
  'vr.insertedHint': 'Added to the field — edit it freely, like any other text.',
  'vr.append': 'Append to the field',
  'vr.replace': 'Replace the field',
  'vr.sttFailedTitle': 'The transcript could not be produced',
  'vr.sttFailedBody':
    'Your recording is safe and will still be saved with the record. Type the text, or try transcribing again.',
  'vr.retryStt': 'Try transcribing again',
  'vr.replaceTitle': 'Record again?',
  'vr.replaceBody': 'Recording again replaces the take you already made.',
  'vr.replaceEffect': 'The earlier recording is deleted and cannot be recovered.',
  'vr.replaceCta': 'Record again',
  'vr.discardTitle': 'Discard this recording?',
  'vr.discardBody': 'The recording is removed from this field.',
  'vr.discardEffect':
    'The audio is deleted and cannot be recovered. Any text you already inserted stays in the field.',
  'vr.discardCta': 'Discard the recording',
  'vr.sectionTitle': 'Voice recordings',
  'vr.sectionSub':
    'Recordings kept with this record. The transcript was a draft — the text above is what the clinician saved.',
  'vr.hadTranscript': 'Transcript produced',
  'vr.noTranscript': 'No transcript',
  'vr.notPlayable': 'No longer available',
  'vr.noneListed': 'No recordings are attached to this record.',
  'vr.listFailed': 'The recordings for this record could not be loaded.',
  'vr.storedTitle': 'About voice recording',
  'vr.storedBody':
    'Recording is optional — typing alone is always enough. If you record, the audio is stored with this clinical record and kept with it, and can be played back later by colleagues who may read this record. It is sent to a transcription service to produce a draft. The transcript is a machine draft: you are responsible for correcting it before saving.',
  'vr.finalizeFailedTitle': 'The record saved, but the recording was not attached',
  'vr.finalizeFailedBody':
    'The clinical text is saved. The audio could not be attached to it just now, so do not assume it was filed — re-record on the saved record, or tell an administrator.',
  'vr.err.generic': 'The recording could not be saved just now.',
  'vr.err.forbidden': 'Recording on this record isn’t part of your role.',
  'vr.err.rateLimited':
    'You have started a lot of recordings recently. Wait a moment and try again.',
  'vr.err.quota':
    'This clinic has reached its transcription allowance for today. The recording can still be typed instead.',
  'vr.err.tooLong': 'That recording is longer or larger than the clinic system accepts.',
  'vr.err.contentInvalid':
    'This browser produced an audio format the clinic system does not accept.',
  'vr.err.storage': 'Storage could not be reached, so the recording was not kept.',
  'vr.err.draftConflict':
    'Another recording for this field was started elsewhere. Reload the page to see the current one.',
  'vr.err.subject': 'This record cannot take a recording on that field.',
  'vr.err.sessionMismatch': 'That recording belongs to a different session and was not attached.',
  'vr.err.state': 'That recording is no longer in a state that allows this.',
  'vr.err.captureStart': 'Recording could not be started in this browser.',
  'vr.err.empty': 'Nothing was captured — check the microphone and record again.',
  /* Assessment completion gate (ZOY-548/552). */
  'ss.gateTitle': 'This session\u2019s assessment is not signed yet',
  'ss.gateBody':
    'A booked assessment session completes only when its OWN assessment is signed off — an assessment from another visit never counts. Sign this session\u2019s assessment, or close the session as incomplete.',
  'ss.gateAhead':
    'Before this session can be recorded as delivered, its own assessment must be signed off.',
  'ss.openAssessment': 'Open this session\u2019s assessment',
  'ss.createAssessment': 'Create this session\u2019s assessment',
  /* Start-before-record and the two honest endings (ZOY-551). */
  'ss.err.notStarted':
    'This session has not been started yet. Open the booking and start the session — the clinical record is written inside a started session.',
  'ss.incompleteNote':
    'If the clinical work could not happen, close the session instead of recording a delivery. Nothing becomes payable and no package progress moves.',
  'ss.rep.title': 'Session reports',
  'ss.rep.cardSub':
    'The clinical report of every delivered session, one after another on a single page.',
  'ss.rep.cardCount':
    '{n, plural, one {# delivered session} other {# delivered sessions}} · latest: {when}',
  'ss.rep.cardNone': 'No session has been delivered yet.',
  'ss.rep.open': 'Read all reports',
  'ss.rep.pageSub':
    'Clinical writing only: session notes, outcome observations and the group report. Nothing financial is shown here.',
  'ss.rep.f.service': 'Service',
  'ss.rep.f.by': 'Therapist',
  'ss.rep.f.from': 'From',
  'ss.rep.f.to': 'To',
  'ss.rep.f.all': 'All',
  'ss.rep.f.clear': 'Clear filters',
  'ss.rep.order': 'Order',
  'ss.rep.order.newest': 'Newest first',
  'ss.rep.order.oldest': 'Oldest first',
  'ss.rep.voided': 'Voided sessions',
  'ss.rep.voidedHelp': 'A voided session does not count; its writing stays readable.',
  'ss.rep.voidedShown': 'Shown',
  'ss.rep.voidedHidden': 'Hidden',
  'ss.rep.count': '{n, plural, one {# session} other {# sessions}} of {total, number}',
  'ss.rep.none': 'No report was written for this session.',
  'ss.rep.empty': 'No session has been delivered on this record yet.',
  'ss.rep.emptyFiltered': 'No session matches these filters.',
  'ss.rep.view': 'View session',
  'ss.notesSubRequired':
    'Write at least one of the two fields — a session is not completed without a report. No templates, categories or scores. After the final save they cannot be edited.',
  'ss.reportRequired': 'Write the session notes or the outcome first.',
  // ZOY-776: extra charges beside sessions.
  'py.alloc.charge_direct': 'applied to the extra charge directly',
  'py.alloc.charge_voided': 'released — extra charge voided',
  'py.xc.title': 'Extra charges',
  'py.xc.chip': 'Extra charge',
  'py.xc.flagged': 'Off default',
  'py.xc.add': 'Add an extra charge',
  'py.xc.kind': 'Kind',
  'py.xc.kindPick': 'Choose',
  'py.xc.minutes': 'Minutes',
  'py.xc.minutesHelp': 'In 15-minute steps; 5 to 480.',
  'py.xc.minutesLess': '15 minutes less',
  'py.xc.minutesMore': '15 minutes more',
  'py.xc.minutesOf': '{minutes} min',
  'py.xc.amount': 'Amount',
  'py.xc.amountDefault': 'This kind’s default: {amount}',
  'py.xc.amountFree': 'This kind has no set rate — type the amount and note why.',
  'py.xc.noteRequired':
    'The amount differs from the default, so a note is required and the report marks it “off default”.',
  'py.xc.note': 'Note',
  'py.xc.practitioner': 'Practitioner',
  'py.xc.practitionerHelp':
    'Required for kinds that count as working time; with a session chosen, it is that session’s practitioner.',
  'py.xc.linkSession': 'Linked session',
  'py.xc.noLink': 'No session',
  'py.xc.save': 'Add charge',
  'py.xc.done': 'Extra charge added — the account above is up to date.',
  'py.xc.void': 'Void',
  'py.xc.voidTitle': 'Void this extra charge',
  'py.xc.voidBody':
    'The row stays with the reason; applied money is released and the account re-settles.',
  'py.xc.voidReason': 'Reason',
  'py.xc.voided': 'Voided',
  'py.xc.voidDone': 'Extra charge voided.',
  'py.xc.payTitle': 'Payment for an extra charge',
  'py.xc.none': 'No extra-charge kinds yet — define them in clinic setup, “Extra charges”.',
  'py.xc.errKindDisabled': 'That kind has been switched off — pick another.',
  'py.xc.errKindGone': 'That kind no longer exists.',
  'py.xc.errSessionVoided':
    'That session was voided — add the charge without a session, or reinstate it first.',
  'py.xc.errNote': 'A note is required for this amount.',
  'py.xc.errMinutes': 'Minutes must be between 5 and 480.',
  'py.xc.errPractitioner': 'This kind needs a practitioner.',
  'py.xc.errAmount': 'Enter an amount greater than zero.',
  'py.xc.errVoided': 'This charge was already voided.',
  'py.xc.errGone': 'This extra charge does not exist for this patient.',
  'py.qp.extrasTitle': 'Extras for this session',
  'py.qp.extraSettle': 'Settle now',
  'py.qp.addExtra': 'Add an extra',
  'py.qp.extraPending': 'Added on confirm',
  'py.qp.remove': 'Remove',
  'py.qp.owesWithExtras': 'Session {session} + extras {extras} = {total}',
  'py.qp.extrasNote':
    'Money goes to this session first, then to the ticked extras; any remainder follows the usual rule.',
  'py.qp.errExtra': 'The extra charge was not added — no payment was recorded either. {detail}',
  'py.qp.addConfirm': 'Add',
  'py.qp.addCancel': 'Cancel',
};
